// main.js
import { createApp } from 'vue'
// import { createRouter, createWebHistory } from 'vue-router'
// import { createStore } from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'

// 不再全局注册VueMarkdown

const app = createApp(App)

app.use(router)
app.use(store)

app.mount('#app')